import { render, staticRenderFns } from "./CheckoutTosCheckbox.vue?vue&type=template&id=82672204&scoped=true"
import script from "./CheckoutTosCheckbox.vue?vue&type=script&lang=ts"
export * from "./CheckoutTosCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./CheckoutTosCheckbox.vue?vue&type=style&index=0&id=82672204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82672204",
  null
  
)

export default component.exports